import { render } from "./AlzataUserList.vue?vue&type=template&id=43323ead"
import script from "./AlzataUserList.vue?vue&type=script&lang=js"
export * from "./AlzataUserList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__